import { VtonImagePoseType } from './type';

export interface VtonState {
    tryOnImage: string | undefined;
    sliderXPercent: number;
    isDragging: boolean;
    isUploading: boolean;
    mapPoseTypeToVtonImage: Map<VtonImagePoseType, { url: string; taffiId: string }>;
    trackVtonScreenViewed: boolean;
}

export type VtonAction =
    | { type: 'SET_TRY_ON_IMAGE'; payload: string | undefined }
    | { type: 'SET_SLIDER_PERCENT'; payload: number }
    | { type: 'SET_IS_DRAGGING'; payload: boolean }
    | { type: 'SET_IS_UPLOADING'; payload: boolean }
    | { type: 'ADD_POSE_TYPE_IMAGE'; payload: { poseType: VtonImagePoseType; url: string; taffiId: string } }
    | { type: 'SET_POSE_TYPE_MAP'; payload: Map<VtonImagePoseType, { url: string; taffiId: string }> }
    | { type: 'RESET_SLIDER'; payload: number }
    | { type: 'SET_TRACK_VTON_SCREEN_VIEWED'; payload: boolean };

export const vtonReducer = (state: VtonState, action: VtonAction): VtonState => {
    switch (action.type) {
    case 'SET_TRY_ON_IMAGE':
        return { ...state, tryOnImage: action.payload };
    case 'SET_SLIDER_PERCENT':
        return { ...state, sliderXPercent: action.payload };
    case 'SET_IS_DRAGGING':
        return { ...state, isDragging: action.payload };
    case 'SET_IS_UPLOADING':
        return { ...state, isUploading: action.payload };
    case 'ADD_POSE_TYPE_IMAGE': {
        const newMap = new Map(state.mapPoseTypeToVtonImage);
        newMap.set(action.payload.poseType, { url: action.payload.url, taffiId: action.payload.taffiId });
        return { ...state, mapPoseTypeToVtonImage: newMap };
    }
    case 'SET_POSE_TYPE_MAP':
        return { ...state, mapPoseTypeToVtonImage: action.payload };
    case 'RESET_SLIDER':
        return { ...state, sliderXPercent: action.payload };
    case 'SET_TRACK_VTON_SCREEN_VIEWED':
        return { ...state, trackVtonScreenViewed: action.payload };
    default:
        return state;
    }
};

export const createInitialState = (modelImageUrl: string | undefined, initialSliderPercentage: number): VtonState => ({
    tryOnImage: modelImageUrl,
    sliderXPercent: initialSliderPercentage,
    isDragging: false,
    isUploading: false,
    mapPoseTypeToVtonImage: new Map<VtonImagePoseType, { url: string; taffiId: string }>(),
    trackVtonScreenViewed: false,
});
